// React&NextJS
import React, { MouseEventHandler, useEffect, useState } from 'react'
// Services&Helper functions
import helperFunctions from '../../../utils/helperFunctions'
// Types
import { Memory as memoryType } from '../../../types/types'
// Styles
import s from '../../../styles/pages/Memory.module.scss'
// Components
import { Button } from '../../../components/core/button/Button'
import { Text } from '../../../components/core/text/Text'
import memoryHelperFunctions from '../../../utils/memoryHelperFunctions'

type Props = {
    memory: memoryType
    readMore: MouseEventHandler<any>
    bioText: JSX.Element | JSX.Element[]
}

const MemoryBio = ({ memory, readMore, bioText }: Props) => {
    const [defaultPage, setDefaultPage] = useState(false)

    useEffect(() => {
        // check if the funeral not finished or person died within 4 weeks: then it is announcement
        let today = new Date()
        if (memoryHelperFunctions.checkIfFuneralFinished(today, memory)) {
            setDefaultPage(true)
        }
    }, [])

    return (
        <>
            {memory.biography &&
                (defaultPage || !memory.announcements.deceased?.text) && (
                    <>
                        <Text variant="p-18" className={s.shortText}>
                            {bioText && helperFunctions.shortendBio(bioText)}
                        </Text>
                        <Button variant="text" onClick={readMore}>
                            Lesa meira
                        </Button>
                    </>
                )}
        </>
    )
}

export default MemoryBio
